import { render, staticRenderFns } from "./questions-details.vue?vue&type=template&id=36ab9fd9"
import script from "./questions-details.vue?vue&type=script&lang=js"
export * from "./questions-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports